module.exports = __webpack_public_path__ + "img/yjcl.26b05a7b.png";